import cn from "classnames";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useSwipeable } from "react-swipeable";

import {
  Modal,
  ModalBody,
  ModalHeading,
  ModalLayout,
  ModalOverflow,
} from "@/components/raffle/results/common-modal/modal.styled";

const SCROLL_AREA_ID = "scroll-area";

export const CommonModal = ({
  header,
  children,
  onHide,
}: {
  header?: React.ReactNode;
  children: React.ReactNode;
  onHide?: () => void;
}) => {
  const [isModalHeaderColored, setIsModalHeaderColored] = useState(false);
  const [initialScroll, setInitialScroll] = useState(0);

  const handleHide = useCallback(() => {
    onHide?.();
  }, [onHide]);

  useEffect(() => {
    const scrollArea = document.getElementById(SCROLL_AREA_ID);
    const firstChild = scrollArea?.firstElementChild;
    if (firstChild) {
      setInitialScroll(firstChild.getBoundingClientRect().top);
    }
  }, []);

  const listener = useRef(() => {});

  useEffect(() => {
    const handleScroll = (firstChild?: Element | null) => {
      setIsModalHeaderColored(
        !!firstChild && firstChild.getBoundingClientRect().top <= initialScroll,
      );
    };

    const scrollArea = document.getElementById(SCROLL_AREA_ID);
    const firstChild = scrollArea?.firstElementChild;
    if (firstChild) {
      listener.current = () => {
        handleScroll(firstChild);
      };
      scrollArea?.addEventListener("scroll", listener.current);
    }
    return () => {
      scrollArea?.removeEventListener("scroll", listener.current);
    };
  }, [initialScroll]);

  useEffect(() => {
    window.document.body.style.overflow = "hidden";
    return () => {
      window.document.body.style.overflow = "";
    };
  }, []);

  const swiper = useSwipeable({
    onSwipedDown: onHide,
  });

  return (
    <Modal>
      <ModalLayout onClick={handleHide} />
      <img
        src="/images/close.svg"
        alt="Close"
        onClick={handleHide}
        className="close"
      />

      <ModalBody className="sm" id={SCROLL_AREA_ID}>
        <div {...swiper} className="swiper" />
        {header && (
          <ModalHeading
            className={cn(isModalHeaderColored && "colored", "padded")}
          >
            {header}
          </ModalHeading>
        )}

        <ModalOverflow className={cn("auto-height", "padded")}>
          {children}
        </ModalOverflow>
      </ModalBody>
    </Modal>
  );
};
